<div [class.hidden]="!visible" class="fixed inset-0 bg-gray-900 bg-opacity-75" (click)="close()" style="z-index:999999;">
  <div class="pt-8 px-4 w-full md:px-0 md:w-3/5 mx-auto">
    <input #queryInput (click)="$event.stopPropagation()" placeholder="Suche nach Artist, Kunde oder Rechnung" type="text" class="styled" ngModel (ngModelChange)="updateQuery($event)" (keydown.enter)="clickFirstResult()" />

    <div *ngIf="!(loading$ | async)" class="mt-2">
      <div (click)="$event.stopPropagation();resultClicked(result)" *ngFor="let result of (results$ | async)" class="py-2 pr-4 pl-16 relative rounded-lg hover:bg-gray-700 mt-1 text-white cursor-pointer">
        <div *ngIf="result.image" class="absolute left-0 vertical-center ml-2">
          <div class="media rounded-full aspect-1-1 w-12">
            <div class="overlay full">
              <img [src]="result.image" alt="" />
            </div>
          </div>
        </div>
        <div class="text-lg font-bold">{{ result.title }}</div>
        <div class="text-sm">
          {{ result.description }}
          <ng-container *ngIf="result.type == 'cooperation'">
            &bull;
            {{ result.data.earliestEvent | date: 'dd.MM.yyyy' }} -
            {{ result.data.latestEvent | date: 'dd.MM.yyyy' }}
          </ng-container>
        </div>
      </div>
    </div>
    <!--
    <app-note-form (submit)="addDoing($event)" #noteForm placeholderText="Doing hinzufügen" [customerSearchEnabled]="true"></app-note-form>-->
  </div>
</div>
